import { render, staticRenderFns } from "./RepxListView.vue?vue&type=template&id=d82a20f0"
import script from "./RepxListView.vue?vue&type=script&lang=js"
export * from "./RepxListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d82a20f0')) {
      api.createRecord('d82a20f0', component.options)
    } else {
      api.reload('d82a20f0', component.options)
    }
    module.hot.accept("./RepxListView.vue?vue&type=template&id=d82a20f0", function () {
      api.rerender('d82a20f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/repx/RepxListView.vue"
export default component.exports